import { EVENTS } from '@/plugins/analytics/events';
import { track } from '@/plugins/analytics';
import type { AssessmentMode } from '../types/assessment-mode.types';

export type AssessmentModeSelectionResult =
  | 'opened'
  | 'auto_selected'
  | 'blocked_offline'
  | 'blocked_unreachable';

export function trackAssessmentModeSelected(
  mode: AssessmentMode,
  result: AssessmentModeSelectionResult,
  component: string,
): void {
  track(EVENTS.FLEXI_MODE_SELECTED, {
    component,
    selected_mode: mode,
    result,
  });
}
